(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lord-home"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  var choice = event.target.closest('[data-lord-builder] button[data-group]');
  if (choice) {
    var builder = choice.closest('[data-lord-builder]');
    var group = choice.getAttribute('data-group');
    builder.querySelectorAll('button[data-group="' + group + '"]').forEach(function(button) {
      button.classList.remove('is-active');
    });
    choice.classList.add('is-active');
  }
  var submit = event.target.closest('[data-builder-submit]');
  if (submit) {
    var root = submit.closest('[data-lord-builder]');
    var values = [];
    ['tech','size','base'].forEach(function(group) {
      var selected = root.querySelector('button[data-group="' + group + '"].is-active');
      if (selected && selected.getAttribute('data-value')) values.push(selected.getAttribute('data-value'));
    });
    window.location.href = '/search?q=' + encodeURIComponent(values.join(' '));
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lord-reference-home"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(e){
  var b=e.target.closest('[data-ref-builder] button[data-group]');
  if(b){
    var root=b.closest('[data-ref-builder]');
    var group=b.getAttribute('data-group');
    root.querySelectorAll('button[data-group="'+group+'"]').forEach(function(x){x.classList.remove('is-active')});
    b.classList.add('is-active');
  }
  var submit=e.target.closest('[data-ref-submit]');
  if(submit){
    var root=submit.closest('[data-ref-builder]');
    var values=[];
    ['tech','size','base'].forEach(function(group){
      var s=root.querySelector('button[data-group="'+group+'"].is-active');
      if(s&&s.getAttribute('data-value'))values.push(s.getAttribute('data-value'));
    });
    window.location.href='/search?q='+encodeURIComponent(values.join(' '));
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lord-reference-product"] && !Shopify.designMode) return;
  try {
    
(function(){
  var rootEl=document.querySelector('[data-lord-pdp]');
  if(!rootEl)return;
  var money=function(cents){return new Intl.NumberFormat('pt-BR',{style:'currency',currency:'BRL'}).format((Number(cents)||0)/100)};
  var variantsEl=rootEl.querySelector('[data-product-variants]');
  var variants=[];
  try{variants=JSON.parse(variantsEl.textContent||'[]')}catch(e){}
  var form=rootEl.querySelector('#LordProductForm');
  var variantInput=rootEl.querySelector('[data-variant-id]');
  var addButton=rootEl.querySelector('[data-add-button]');
  var buyNowButton=rootEl.querySelector('[data-buy-now]');
  var priceEl=rootEl.querySelector('#LordProductPrice');
  var installmentEl=rootEl.querySelector('#LordProductInstallment');

  var galleryThumbs=Array.from(rootEl.querySelectorAll('[data-lord-thumb]'));
  var galleryPrev=rootEl.querySelector('[data-gallery-prev]');
  var galleryNext=rootEl.querySelector('[data-gallery-next]');
  var galleryMain=rootEl.querySelector('#LordMainProductImage');
  var galleryFrame=rootEl.querySelector('.lord-pdp__main-image');
  var galleryIndex=Math.max(0,galleryThumbs.findIndex(function(x){return x.classList.contains('is-active')}));
  function showGalleryImage(index){
    if(!galleryThumbs.length||!galleryMain)return;
    galleryIndex=(index+galleryThumbs.length)%galleryThumbs.length;
    var thumb=galleryThumbs[galleryIndex];
    galleryThumbs.forEach(function(x){x.classList.remove('is-active')});
    thumb.classList.add('is-active');
    galleryMain.src=thumb.getAttribute('data-full');
    galleryMain.removeAttribute('srcset');
    galleryMain.removeAttribute('sizes');
    var ratio=parseFloat(thumb.getAttribute('data-ratio')||'0');
    if(galleryFrame&&ratio>0)galleryFrame.style.aspectRatio=String(ratio);
  }
  galleryThumbs.forEach(function(btn,index){
    btn.addEventListener('click',function(){showGalleryImage(index)});
  });
  if(galleryThumbs.length<=1){
    if(galleryPrev)galleryPrev.hidden=true;
    if(galleryNext)galleryNext.hidden=true;
  }else{
    if(galleryPrev)galleryPrev.addEventListener('click',function(){showGalleryImage(galleryIndex-1)});
    if(galleryNext)galleryNext.addEventListener('click',function(){showGalleryImage(galleryIndex+1)});
  }
  if(galleryFrame&&galleryThumbs[galleryIndex]){
    var initialRatio=parseFloat(galleryThumbs[galleryIndex].getAttribute('data-ratio')||'0');
    if(initialRatio>0)galleryFrame.style.aspectRatio=String(initialRatio);
  }

  var optionGroups=Array.from(rootEl.querySelectorAll('[data-option-index]'));
  function resolveVariant(){
    if(!optionGroups.length)return;
    var values=optionGroups.map(function(group){
      var selected=group.querySelector('[data-option-value].is-selected');
      return selected?selected.getAttribute('data-option-value'):null;
    });
    var variant=variants.find(function(v){
      return v.options && v.options.every(function(opt,i){return opt===values[i]});
    });
    if(!variant)return;
    variantInput.value=variant.id;
    if(priceEl)priceEl.textContent=money(variant.price);
    if(installmentEl)installmentEl.textContent='ou 10x de '+money(Math.round(variant.price/10))+' sem juros';
    if(addButton){
      addButton.disabled=!variant.available;
      addButton.textContent=variant.available?'ADICIONAR AO CARRINHO':'INDISPONÍVEL';
    }
    if(buyNowButton){
      buyNowButton.disabled=!variant.available;
      buyNowButton.textContent=variant.available?'COMPRAR AGORA':'INDISPONÍVEL';
    }
    try{history.replaceState({},'',location.pathname+'?variant='+variant.id)}catch(e){}
    if(variant.featured_image&&variant.featured_image.src){
      var main=rootEl.querySelector('#LordMainProductImage');
      if(main)main.src=variant.featured_image.src;
    }
  }
  optionGroups.forEach(function(group){
    group.querySelectorAll('[data-option-value]').forEach(function(btn){
      btn.addEventListener('click',function(){
        group.querySelectorAll('[data-option-value]').forEach(function(x){x.classList.remove('is-selected')});
        btn.classList.add('is-selected');
        resolveVariant();
      });
    });
  });

  var sibling=rootEl.querySelector('[data-sibling-selector]');
  var context={};
  try{context=JSON.parse(rootEl.querySelector('[data-product-context]').textContent||'{}')}catch(e){}
  if(sibling){
    var title=(context.title||'').toLowerCase();
    var family='';
    if(title.indexOf('d33')>-1)family='D33';
    else if(title.indexOf('d45')>-1)family='D45';
    else if(title.indexOf('bonnel')>-1)family='Bonnel';
    else if(title.indexOf('ensacada')>-1)family='Ensacada';
    else if(title.indexOf('base box baú')>-1||title.indexOf('base box bau')>-1)family='Base Box Baú';

    var currentColor=['Azul','Bege','Cinza','Marrom','Preto','Vinho'].find(function(x){return title.indexOf(x.toLowerCase())>-1})||'';
    var currentSize=['78x188','88x188','128x188','138x188','158x198','198x203'].find(function(x){return title.indexOf(x.toLowerCase())>-1})||'';
    var mh=title.match(/(?:78x188|88x188|128x188|138x188|158x198|198x203)x(14|17|20|24|28)/);
    var currentHeight=mh?mh[1]:'';
    var premium=title.indexOf('premium')>-1;

    if(family && (premium || family==='Base Box Baú')){
      sibling.hidden=false;
      if(family==='Base Box Baú')rootEl.querySelector('[data-sibling-group="height"]').hidden=true;
      if(!currentSize && family==='Base Box Baú')currentSize='138x188';
      ['color','size','height'].forEach(function(dim){
        var current=dim==='color'?currentColor:(dim==='size'?currentSize:currentHeight);
        rootEl.querySelectorAll('[data-sibling-dim="'+dim+'"]').forEach(function(btn){
          if(btn.getAttribute('data-sibling-value')===current)btn.classList.add('is-current');
        });
      });

      sibling.querySelectorAll('[data-sibling-dim]').forEach(function(btn){
        btn.addEventListener('click',async function(){
          var dim=btn.getAttribute('data-sibling-dim');
          var value=btn.getAttribute('data-sibling-value');
          var color=dim==='color'?value:currentColor;
          var size=dim==='size'?value:currentSize;
          var height=dim==='height'?value:currentHeight;
          var q='';
          if(family==='Base Box Baú'){
            q='Base Box Baú '+(size||'138x188')+' Suede '+color;
          }else{
            q='Colchão '+family+' '+size+(height?'x'+height:'')+' Lateral '+color+(premium?' PREMIUM':'');
          }
          var status=sibling.querySelector('[data-sibling-status]');
          status.textContent='Buscando esta combinação...';
          try{
            var base=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
            var url=base+'search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=show';
            var response=await fetch(url);
            var data=await response.json();
            var products=(((data||{}).resources||{}).results||{}).products||[];
            var normalized=function(s){return (s||'').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'')};
            var tokens=normalized(q).split(/\s+/).filter(function(x){return x.length>1});
            var match=products.sort(function(a,b){
              var sa=tokens.filter(function(t){return normalized(a.title).indexOf(t)>-1}).length;
              var sb=tokens.filter(function(t){return normalized(b.title).indexOf(t)>-1}).length;
              return sb-sa;
            })[0];
            if(match&&match.url){window.location.href=match.url;return}
            status.textContent='Essa combinação ainda não está disponível. Fale com a LORD no WhatsApp.';
          }catch(err){
            status.textContent='Não foi possível localizar a combinação agora.';
          }
        });
      });
    }
  }

  if(buyNowButton){
    buyNowButton.addEventListener('click',async function(){
      if(buyNowButton.disabled)return;
      var variantId=variantInput.value;
      var qty=parseInt((rootEl.querySelector('[data-quantity]')||{}).value||'1',10);
      if(!variantId)return;
      var originalText=buyNowButton.textContent;
      buyNowButton.disabled=true;
      buyNowButton.textContent='INDO PARA O CHECKOUT...';
      try{
        var base=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
        var response=await fetch(base+'cart/add.js',{
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({id:Number(variantId),quantity:qty})
        });
        if(!response.ok)throw new Error(await response.text());
        window.location.href=base+'checkout';
      }catch(err){
        buyNowButton.disabled=false;
        buyNowButton.textContent=originalText;
        alert('Não foi possível iniciar a compra agora. Tente novamente ou use Adicionar ao carrinho.');
      }
    });
  }

  var zipInput=rootEl.querySelector('[data-shipping-zip]');
  var calcButton=rootEl.querySelector('[data-shipping-calc]');
  var resultEl=rootEl.querySelector('[data-shipping-result]');
  if(zipInput){
    zipInput.addEventListener('input',function(){
      var v=zipInput.value.replace(/\D/g,'').slice(0,8);
      zipInput.value=v.length>5?v.slice(0,5)+'-'+v.slice(5):v;
    });
  }
  var formatBRL=function(value){
    return new Intl.NumberFormat('pt-BR',{style:'currency',currency:'BRL'}).format(value);
  };
  var inRange=function(zip,start,end){return zip>=start&&zip<=end};
  var interior1Ranges=[
    [12000001,12119999],
    [12200001,12249999],
    [12280001,12299999],
    [12300001,12349999],
    [13000000,13109999],
    [13140001,13149999],
    [13150001,13159999],
    [13160001,13169999],
    [13170001,13182999],
    [13183001,13189999],
    [13190001,13199999],
    [13200001,13219999],
    [13250001,13259999],
    [13270001,13279999],
    [13280001,13289999],
    [13295001,13299999],
    [13330001,13349999],
    [13380001,13389999],
    [13450001,13464999],
    [13480001,13489999]
  ];
  var classifyShipping=function(zipString){
    var zip=Number(zipString);
    if(inRange(zip,1000000,5999999)||inRange(zip,8000000,8499999)){
      return {region:'SP Capital',price:105};
    }
    if(inRange(zip,11000000,11599999)||inRange(zip,11700000,11799999)){
      return {region:'Baixada Santista',price:249};
    }
    var isInterior1=interior1Ranges.some(function(r){return inRange(zip,r[0],r[1])});
    if(isInterior1){
      return {region:'SP Interior 1',price:284};
    }
    if(inRange(zip,1000000,19999999)){
      return {region:'Demais regiões de SP',price:299};
    }
    return null;
  };
  if(calcButton){
    calcButton.addEventListener('click',function(){
      var zip=(zipInput.value||'').replace(/\D/g,'');
      if(zip.length!==8){
        resultEl.innerHTML='<span style="color:#d9ba52">Digite um CEP válido com 8 números.</span>';
        return;
      }
      var quote=classifyShipping(zip);
      if(!quote){
        resultEl.innerHTML='<span style="color:#d9ba52"><strong>Não atendemos este CEP.</strong><br>No momento, a LORD realiza entregas somente no estado de São Paulo.</span>';
        return;
      }
      resultEl.innerHTML=
        '<div class="lord-freight-rate"><span>Frete fixo — '+quote.region+'</span><strong>'+formatBRL(quote.price)+'</strong></div>'+
        '<span style="color:#888;font-size:11px">Valor calculado pela faixa do CEP informado.</span>';
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
